import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerTrust implements IOwner {
    constructor(owner: OwnerTrust) {
        Object.assign(this, owner);
    }

    id: number;
    ownerType: string;
    containerOwnerId: number;
    ownerLookUpId: number;
    trustName: string;
    trustees: string;
    address: Address;
    phoneNumberChanges?: PhoneNumberChanges;
    contactPersonDetailsId: number;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    phoneNumber: string;
    email: string;
    addressInformationDate: Date;
    note: string;
    isPrimaryDeviation: boolean;
    isClientAcreage: boolean;
    ssnTaxId: string;

    ownerName() {
        return this.trustName;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerTrust.ts